import React, { useEffect, useRef } from 'react'
import constants from '../constants'
import Picture from './picture'
import Arrow from '../../public/years-img/arrow.svg'
import Grid from './grid'
import {gsap} from 'gsap'
import { SplitText } from "gsap/SplitText.js"

gsap.registerPlugin(SplitText)

const Welcome = ({titleContent}) => {
  const titleEl = useRef()
  const subEl = useRef()
  useEffect(() => {
    const split = new SplitText(titleEl.current, {type: constants.SPLIT_ONLY_WORDS ? "words, lines" : "chars, lines", linesClass: "tw-whitespace-nowrap" })
    const tl = gsap.timeline()
    tl.from(subEl.current, {duration: 1, y: 10, autoAlpha: 0, ease: `expo.out`}, 0)
    tl.from(constants.SPLIT_ONLY_WORDS ? split.words : split.chars, {duration: 1, y: window.isMobile ? 20 : 40, autoAlpha: 0, stagger: 0.05, ease: `expo.out`, force3D: true}, 0.1)
    tl.pause(0)
    setTimeout(() => {
      tl.play()
    })
  })
  const datesStyle = { fontSize: window.isMobile ? `31.2vw` : `25.2vw`, lineHeight: `16vw`, color: `transparent`, WebkitTextStroke: `1px`,  WebkitTextStrokeColor: `#B59860` }
  const year = new Date().getFullYear()
  return (
    <section data-anchor={`welcome`} className={`welcome-section block-section tw-mt-10`}>
      <a name={`LA MAISON`} className={`tw-relative tw--top-20`} />
      <Grid>
        <div ref={subEl} className={`${constants.h5} tw-col-start-1 tw-col-end-13 tw-text-center tw-uppercase tw-text-red tw-font-sans`}>{constants.UI.home}</div>
        <h1 ref={titleEl} style={{ letterSpacing: LANG_ID === 'ar' ? 0 : 'auto' }} className={`direction-assign tw-col-start-1 tw-col-end-13 tw-mt-6 tw-text-center tw-uppercase tw-font-sans tw-text-4xl lg:tw-text-5xl xl:tw-text-6xl 2xl:tw-text-7xl tw-w-11/12 lg:tw-w-6/12 tw-mx-auto`} dangerouslySetInnerHTML={{ __html: titleContent }}/>
        <div className={`tw-col-start-1 tw-col-end-13 lg:tw-col-start-3 lg:tw-col-end-11 tw-mt-16 lg:tw-mt-8`}>
          <div className={`tw-relative`}>
            <Picture
              animation={`translate-y`}
              translate={60}
              filename={`DiademNH_1326553_1977`}
              className={`tw-transform 2xl:scale-75`}
            />
            <div className={`tw-absolute tw-top-0 lg:tw-top-8 tw-left-0 tw-w-full tw-z-20 tw-font-sans`}>
              <div className={`tw-inline-block tw-transform tw--translate-x-1/2 tw-relative tw-left-1/2 tw-space-y-10 lg:tw-space-y-16`}>
                <div className={`block-date tw-whitespace-nowrap tw-flex tw-justify-center`} style={datesStyle}>1847</div>
                <div className={`block-date tw-whitespace-nowrap tw-flex tw-justify-center`} style={datesStyle}>{year}</div>
              </div>
            </div>
          </div>
        </div>
        <a className={`tw-animate-bounce tw-col-start-7 tw-col-end-8 tw-mt-10 lg:tw-mt-16 tw-mb-4`} href='#1847'>
          <img src={Arrow} />
        </a>
      </Grid>
    </section>
  )
}

export default Welcome
